import React, { useState, useEffect, useRef } from "react";

// TopRightOverlay와 동일한 빈티지 문서 스타일
const VINTAGE_STYLES = {
  label: {
    color: "#666655",
    fontSize: "11px",
    fontWeight: 600 as const,
    textTransform: "uppercase" as const,
    letterSpacing: "1px",
    marginBottom: "4px",
  },
  input: {
    width: "100%",
    padding: "8px 10px",
    fontSize: "13px",
    fontFamily: "'Pretendard GOV Variable','Noto Serif KR', 'Georgia', serif",
    background: "#faf8f0",
    border: "1px solid #d4c9b0",
    borderRadius: "3px",
    color: "#2a2a2a",
    outline: "none",
    boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05)",
  },
};

interface EditorBuildingInfoProps {
  buildingName: string;
  setBuildingName: (name: string) => void;
  buildingText: string;
  setBuildingText: (text: string) => void;
}

/**
 * 건물 정보 입력 컴포넌트 - 빈티지 스타일
 * 한글 IME 문제를 해결하기 위해 로컬 상태 버퍼 사용
 */
export function EditorBuildingInfo({
  buildingName,
  setBuildingName,
  buildingText,
  setBuildingText,
}: EditorBuildingInfoProps) {
  // 로컬 상태 버퍼 (한글 IME 문제 해결)
  const [localName, setLocalName] = useState(buildingName);
  const [localText, setLocalText] = useState(buildingText);
  const isComposingRef = useRef(false);

  // props가 외부에서 변경되면 로컬 상태 동기화
  useEffect(() => {
    if (!isComposingRef.current) {
      setLocalName(buildingName);
    }
  }, [buildingName]);

  useEffect(() => {
    if (!isComposingRef.current) {
      setLocalText(buildingText);
    }
  }, [buildingText]);

  return (
    <div
      className="space-y-4"
      style={{ fontFamily: "'Noto Serif KR', 'Georgia', serif" }}
    >
      {/* 건물 이름 */}
      <div>
        <label className="block" style={VINTAGE_STYLES.label}>
          건물 명칭
        </label>
        <input
          type="text"
          value={localName}
          onChange={(e) => {
            setLocalName(e.target.value);
            if (!isComposingRef.current) {
              setBuildingName(e.target.value);
            }
          }}
          onCompositionStart={() => {
            isComposingRef.current = true;
          }}
          onCompositionEnd={(e) => {
            isComposingRef.current = false;
            const target = e.target as HTMLInputElement;
            setBuildingName(target.value);
          }}
          onKeyDown={(e) => e.stopPropagation()}
          placeholder="예: 평화 아파트"
          style={VINTAGE_STYLES.input}
        />
      </div>

      {/* 건물 설명 */}
      <div>
        <label className="block" style={VINTAGE_STYLES.label}>
          건물 한줄 설명
        </label>
        <input
          type="text"
          value={localText}
          onChange={(e) => {
            const val = e.target.value.slice(0, 50);
            setLocalText(val);
            if (!isComposingRef.current) {
              setBuildingText(val);
            }
          }}
          onCompositionStart={() => {
            isComposingRef.current = true;
          }}
          onCompositionEnd={(e) => {
            isComposingRef.current = false;
            const target = e.target as HTMLInputElement;
            setBuildingText(target.value.slice(0, 50));
          }}
          onKeyDown={(e) => e.stopPropagation()}
          placeholder="예: 모두가 행복한 공간"
          style={VINTAGE_STYLES.input}
        />
      </div>
    </div>
  );
}
